"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LifeRequest = void 0;
var LifeRequest = /** @class */ (function () {
    function LifeRequest() {
    }
    return LifeRequest;
}());
exports.LifeRequest = LifeRequest;
;
//# sourceMappingURL=life.request.js.map